/* @flow */

import Edit from './Edit';
import View from './View';

export type GalleryContentImage = {
  order?: number,
  title?: string,
  image?: CatalogResource,
};

export type GalleryContent = {
  items: Array<GalleryContentImage>,
};

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/gallery/index.js